const miniCart = typeof window !== 'undefined' && window && window.MiniCart || {};
const catalystMinicart = typeof window !== 'undefined' && window && window.Catalyst && window.Catalyst.Minicart || {};

const miniCartClient = {
    refresh() {
        return miniCart.refresh && miniCart.refresh();
    },
    show() {
        miniCart.show && miniCart.show();
    },
    hide() {
        miniCart.hide && miniCart.hide();
    },
    refreshAndShow() {
        miniCart.refreshAndShow && miniCart.refreshAndShow();
    },
    updateCart(cartName) {
        catalystMinicart.updateCart && catalystMinicart.updateCart(cartName);
    }
};

export default miniCartClient;